import React from "react";

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		//TODO: log error to reporting service
	}

	render() {
		if (this.state.hasError) {
			//TODO: prettier error message
			return <h1>ERRO: Algo correu mal.</h1>;
		}

		return this.props.children;
	}
}
